import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import api from '@/services/api';

export default function Contract() {
    const [checked, setChecked] = useState(false);
    const [loading, setLoading] = useState(false);
    const nav = useNavigate();
    const { refreshAgent, logout } = useAuth();

    const accept = async () => {
        setLoading(true);
        try {
            // 🔴 این مسیر را با بک‌اندت هماهنگ کن
            await api.post('/contract/accept');
            await refreshAgent();
            nav('/dashboard', { replace: true });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-6">
            <div className="w-full max-w-3xl rounded-2xl border p-6">
                <h1 className="text-xl font-bold">قرارداد همکاری</h1>

                <div className="mt-4 h-[55vh] overflow-auto border rounded-xl p-4 text-sm">
                    متن قرارداد اینجا نمایش داده می‌شود...
                    {/* اگر از سرور می‌گیری: api.get('/contract') */}
                </div>

                <label className="mt-4 flex items-center gap-2 text-sm">
                    <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} />
                    قرارداد را خواندم و قبول می‌کنم
                </label>

                <div className="mt-4 flex gap-2">
                    <button
                        className="px-4 py-2 rounded-lg bg-emerald-600 text-white disabled:opacity-50"
                        disabled={!checked || loading}
                        onClick={accept}
                    >
                        {loading ? 'در حال ثبت...' : 'قبول می‌کنم'}
                    </button>

                    <button className="px-4 py-2 rounded-lg border" onClick={logout}>
                        خروج
                    </button>
                </div>
            </div>
        </div>
    );
}
